import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isEmpty from "lodash/isEmpty";
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Body, Title } from '@nerdwallet/currency';
import Box from '@nerdwallet/react-box';
import LoadingN from '@nerdwallet/react-loading-n';
import VerticalCarousel from '@nerdwallet/react-vertical-carousel';
import style from './loading-screen.module.less'; // This is because vertical carousel is not using less modules just yet

require('@nerdwallet/react-vertical-carousel/vertical-carousel.less');

var LoadingScreen = /*#__PURE__*/function (_Component) {
  _inherits(LoadingScreen, _Component);

  var _super = _createSuper(LoadingScreen);

  function LoadingScreen() {
    _classCallCheck(this, LoadingScreen);

    return _super.apply(this, arguments);
  }

  _createClass(LoadingScreen, [{
    key: "showRotatingText",
    value: function showRotatingText() {
      var rotatingListOfText = this.props.rotatingListOfText;
      return !_isEmpty(rotatingListOfText);
    }
  }, {
    key: "renderRotatingText",
    value: function renderRotatingText() {
      var _this$props = this.props,
          rotatingListCycleRate = _this$props.rotatingListCycleRate,
          rotatingListOfText = _this$props.rotatingListOfText,
          textBeforeRotatingText = _this$props.textBeforeRotatingText;

      if (!this.showRotatingText()) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: style.rotator
      }, textBeforeRotatingText && /*#__PURE__*/React.createElement(Title, {
        size: "small",
        className: style.pretext
      }, textBeforeRotatingText), /*#__PURE__*/React.createElement("div", {
        className: style.carousel
      }, /*#__PURE__*/React.createElement(VerticalCarousel, {
        elements: rotatingListOfText,
        cycleRate: rotatingListCycleRate,
        height: 24
      })));
    }
  }, {
    key: "renderLoadingIcon",
    value: function renderLoadingIcon() {
      if (this.showRotatingText()) {
        return /*#__PURE__*/React.createElement("img", {
          src: "https://www.nerdwallet.com/cdn/img/icons/Nerdwallet_N.svg",
          alt: "",
          className: classnames(style.loading, style.icon)
        });
      }

      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(LoadingN, {
        size: 48,
        className: classnames(style.loading, style.mobile)
      }), /*#__PURE__*/React.createElement(LoadingN, {
        size: 64,
        className: classnames(style.loading, style.desktop)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          subtitle = _this$props2.subtitle,
          title = _this$props2.title;
      return /*#__PURE__*/React.createElement("div", {
        className: style.container
      }, this.renderLoadingIcon(), /*#__PURE__*/React.createElement(Box, {
        wide: {
          columns: 6
        },
        notWide: {
          columns: 4
        },
        className: style.textContainer
      }, /*#__PURE__*/React.createElement(Title, {
        size: "medium",
        className: style.title
      }, title), subtitle && /*#__PURE__*/React.createElement(Body, null, subtitle), this.renderRotatingText()));
    }
  }]);

  return LoadingScreen;
}(Component);

_defineProperty(LoadingScreen, "displayName", 'LoadingScreen');

_defineProperty(LoadingScreen, "propTypes", {
  /** subtitle in the screen */
  subtitle: PropTypes.string,

  /** rate (in milliseconds) at which the list of text is rotating */
  rotatingListCycleRate: PropTypes.number,

  /** a list of text to rotate through */
  rotatingListOfText: PropTypes.arrayOf(PropTypes.string),

  /** text before rotating text */
  textBeforeRotatingText: PropTypes.string,

  /** title in the screen */
  title: PropTypes.string.isRequired
});

_defineProperty(LoadingScreen, "defaultProps", {
  subtitle: null,
  rotatingListCycleRate: 2000,
  rotatingListOfText: null,
  textBeforeRotatingText: null
});

export default LoadingScreen;